import React from "react";

import { Select } from "@aclymatepackages/atoms";

import { useSurveyLanguage } from "../../../helpers/contexts/surveyLanguage";

const VehicleYearSelect = ({
  error,
  year,
  editVehicle,
  noLabel = false,
  id,
  smallFont,
  variant
}) => {
  const { translate } = useSurveyLanguage();

  return (
    <Select
      id={id}
      size="small"
      label={noLabel ? "" : translate("vehicles.vehicleYear")}
      value={year || ""}
      editValue={editVehicle}
      error={error}
      options={[...new Array(30)]
        .map((_, idx) => Number(new Date().getFullYear()) - idx)
        .map((option) => ({ label: option, value: option }))}
      smallFont={smallFont}
      variant={variant}
    />
  );
};
export default VehicleYearSelect;
